const stripTrailingSlash = value => value.replace(/\/+$/, '')

export const resolveApiBaseUrl = rawBaseUrl => {
  if (!rawBaseUrl)
    return ''

  const normalized = stripTrailingSlash(rawBaseUrl.trim())

  // Most of the app passes endpoints starting with `/api/...`.
  // If the env var already ends with `/api`, keep only the origin/base path
  // to avoid producing `/api/api/...`.
  if (normalized.endsWith('/api'))
    return normalized.slice(0, -4)

  return normalized
}
